/** Скидка в чеке только для partner/admin и только если % > 0 (как на бэкенде). */
export function effectivePartnerDiscountPct(
  role: string | null | undefined,
  partnerDiscountPct: number | null | undefined,
): number {
  const r = (role || '').toLowerCase()
  if (r !== 'partner' && r !== 'admin') return 0
  const pct = Number(partnerDiscountPct ?? 0)
  if (!Number.isFinite(pct) || pct <= 0) return 0
  return Math.min(100, pct)
}
